// extracted by mini-css-extract-plugin
export default {"app":"_1CPxc","scrollable":"_3XnvP","postPageApp":"_2QGTK"};